import React from 'react'
import { committeeElement,Breadcrumb } from './myFunctions'
export default function CommitteeListEntry({oym,committee,dropBreadcrumb,authenticated}) {
    console.log(oym);
    let committeeObject=oym.objectRef(committee);
    console.log(committee,committeeObject);
    function dropCommitteeBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb(committeeObject.name,committeeElement(oym,committee,dropBreadcrumb,authenticated)));
    }
    return (
        <div>
            <button onClick={dropCommitteeBreadcrumb}>{committeeObject.name}</button>
        </div>
    )
}
